// @see: https://v8.i18n.nuxtjs.org/getting-started/basic-usage/#translate-with-vue-i18n
import i18nConfig from '~dsc/locales/i18n.config';
export default defineI18nConfig(() => (Object.assign(i18nConfig, {
    locale: 'sv-SE',
})));
